class InstallationOptionSerializer {
  static deSerialize(data) {
    const deSerializedOptions = [];
    data.forEach((item) => {
      (item.FechaHorario || []).forEach((option) => {
        deSerializedOptions.push({
          availableInstallations: option.CuposDisponible,
          endHour: option.HoraFin,
          extraCost: item.CostoViatico,
          date: option.Fecha,
          startHour: option.HoraInicio,
        });
      });
    });
    return deSerializedOptions;
  }
}

export { InstallationOptionSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/InstallationOptionSerializer.js